module.exports = __webpack_public_path__ + "img/school_icon.6ce993e6.png";